import { Alert as MuiAlert } from '@mui/material';

const toneStyles = {
  neutral: {
    bgcolor: 'rgba(255, 253, 248, .92)',
    color: 'text.primary',
    borderColor: 'rgba(26, 29, 49, .14)',
    '& .MuiAlert-icon': { color: 'primary.main' },
    '& .MuiAlert-action': { color: 'text.primary' },
  },
  success: {
    bgcolor: 'rgba(70, 201, 142, .10)',
    color: 'text.primary',
    borderColor: 'rgba(47, 165, 113, .24)',
    '& .MuiAlert-icon': { color: 'success.dark' },
    '& .MuiAlert-action': { color: 'text.primary' },
  },
  warning: {
    bgcolor: 'rgba(255, 182, 72, .14)',
    color: 'text.primary',
    borderColor: 'rgba(226, 146, 31, .28)',
    '& .MuiAlert-icon': { color: 'primary.dark' },
    '& .MuiAlert-action': { color: 'text.primary' },
  },
  error: {
    bgcolor: 'rgba(255, 142, 122, .12)',
    color: 'text.primary',
    borderColor: 'rgba(255, 142, 122, .34)',
    '& .MuiAlert-icon': { color: 'error.main' },
    '& .MuiAlert-action': { color: 'text.primary' },
  },
};

export function NudgeAlert({ tone, severity = 'neutral', sx = {}, ...props }) {
  const resolvedTone = tone || (severity === 'info' ? 'neutral' : severity) || 'neutral';
  const safeTone = toneStyles[resolvedTone] ? resolvedTone : 'neutral';
  const muiSeverity = safeTone === 'neutral' ? 'warning' : safeTone;

  return (
    <MuiAlert
      variant="outlined"
      severity={muiSeverity}
      sx={{
        borderRadius: 1.2,
        alignItems: 'center',
        fontWeight: 500,
        boxShadow: '0 12px 30px rgba(26, 29, 49, .04)',
        ...toneStyles[safeTone],
        ...sx,
      }}
      {...props}
    />
  );
}
